import React, { createContext, useContext, useState, useEffect } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";
import { useTheme } from "@/context/ThemeContext";

const CursorContext = createContext(null);

export const CursorProvider = ({ children }) => {
  const [variant, setVariant] = useState("default"); // default | play | link
  const setCursor = (v) => setVariant(v);
  const reset = () => setVariant("default");
  return (
    <CursorContext.Provider value={{ variant, setCursor, reset }}>
      {children}
      <CustomCursor variant={variant} />
    </CursorContext.Provider>
  );
};

export const useCursor = () => useContext(CursorContext);

const CustomCursor = ({ variant }) => {
  const { theme } = useTheme();
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const springCfg = { damping: 28, stiffness: 400, mass: 0.4 };
  const sx = useSpring(x, springCfg);
  const sy = useSpring(y, springCfg);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const isFine = window.matchMedia("(pointer: fine)").matches;
    if (!isFine) return;
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setVisible(true);
    };
    window.addEventListener("mousemove", move);
    return () => window.removeEventListener("mousemove", move);
  }, [x, y]);

  const isPlay = variant === "play";
  const isLink = variant === "link";

  return (
    <motion.div
      aria-hidden
      className="hidden md:flex fixed top-0 left-0 z-[9999] items-center justify-center rounded-full pointer-events-none"
      style={{ x: sx, y: sy, translateX: "-50%", translateY: "-50%" }}
      animate={{
        width: isPlay ? 88 : isLink ? 56 : 12,
        height: isPlay ? 88 : isLink ? 56 : 12,
        backgroundColor: isPlay ? "#000080" : isLink ? "rgba(120,120,140,0.16)" : (theme === "light" ? "#0E0E10" : "#F5F3EE"),
        opacity: visible ? 1 : 0,
      }}
      transition={{ type: "spring", damping: 20, stiffness: 300, mass: 0.5 }}
    >
      {isPlay && (
        <span className="font-mono text-[10px] tracking-[0.2em] text-white uppercase">Play</span>
      )}
    </motion.div>
  );
};
